module.exports = __webpack_public_path__ + "static/media/empresa4.732aa63b.jpg";